// extracted by mini-css-extract-plugin
export default {"skip-to-content-button":"LHrbPP","skipToContentButton":"LHrbPP"};